<div class="bottomtable ">

 <div class="d-flex align-items-center gap-2">
  <p class="mb-0">Records per page:</p>
  <div class="custom-dropdown dropdown">
    <button class="btn custom-toggle " type="button" data-bs-toggle="dropdown">
      <strong>{{ pageSize }}</strong>
      <img src="/assets/confirmation-msg/CaretDown.svg" alt="Dropdown Icon" />
    </button>
    <ul class="dropdown-menu">
      <li *ngFor="let size of [10, 20, 50]">
        <a class="dropdown-item" (click)="onSizeChange(size)">{{ size }}</a>
      </li>
    </ul>
  </div>
</div>

  

  <div class="pagination">
    <!-- <img (click)="goToPage(pageAll - 1)"  src="/assets/bookingIcon/pr.png"> -->
    <button class="page-btn"id="previousbtn"
            (click)="goToPage(pageAll - 1)"
            [disabled]="pageAll === 1">
      &lt;
    </button>

    <!-- Page Numbers with Ellipsis -->
    <ng-container *ngFor="let page of pages">
      <button 
        class="page-number"
        [class.active]="page === pageAll"
        [disabled]="page === '...'"
        (click)="goToPage(page)">
        {{ page }}
      </button>
    </ng-container>

    <!-- <img (click)="goToPage(pageAll + 1)"  src="/assets/bookingIcon/Nexts.png"> -->
     <button id="nextbtn" class="page-btn"(click)="goToPage(pageAll + 1)" [disabled]="pageAll === totalPages"> &gt;
    </button> 
  </div>

  <div class="d-flex align-items-center gap-2 mt-2">
    <label class="mb-0">Jump to page</label>
    <input type="number"
           class="form-control form-control-sm " style="width: 50px;"
           [(ngModel)]="jumpPageInput"
           min="1"
           [max]="totalPages"
           (keyup.enter)="jumpToPage()" />

    <button class="buttongo text-white"
            [disabled]="jumpPageInput < 1 || jumpPageInput > totalPages"
            (click)="jumpToPage()">Go</button>
  </div>

</div>
